import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { getUserLocal, LocalSettingsKey } from '@shared/types/local-settings';
import { RefreshTokenService } from '@service/rest/refresh-token/refresh-token.service';
import { first } from 'rxjs/operators';
import { SessionUtilsService } from '@service/rest/login/session-utils.service';
import { LogoutService } from '@service/rest/login/logout.service';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenResolver implements Resolve<boolean> {

  constructor(
    private refreshTokenService: RefreshTokenService,
    private logoutService: LogoutService
  ) { }

  resolve(): Observable<boolean> {
    localStorage.removeItem(LocalSettingsKey.IS_TOKEN_RENEWING);
    const user = getUserLocal();
    // refresh tokeni yoksa yada süresi bitmişse logout yapıyoruz.
    if (!user?.refresh_token || !SessionUtilsService.tokenHasTimeByType('refresh')) {
      this.logout();
      return of(false);
      // userın access_tokeni yoksa yada süresi bitmişse; refresh_tokeni ve refresh_tokenin süresi varsa yeni token üretiyoruz.
    } else if (user?.refresh_token && SessionUtilsService.tokenHasTimeByType('refresh') && (!user.token || !SessionUtilsService.tokenHasTimeByType())) {
      this.refreshTokenService.refreshToken().pipe(first()).subscribe((res) => {
        setTimeout(() => {
          return of(true);
        });
      }, () => {
        this.logout();
        return of(false);
      });
    }
  }

  private logout(): void {
    this.logoutService.clearAfterLogout(true);
  }
}
